import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flexDirection"];
import { forwardRef } from 'react';
import { LayoutFlex } from './LayoutFlex';
import { jsx as _jsx } from "react/jsx-runtime";
export const LayoutVertical = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      flexDirection = 'column'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutFlex, Object.assign({}, rest, {
    flexDirection: flexDirection,
    ref: ref,
    children: children
  }));
});